/**
 * Type guard to check if a value is neither null nor undefined.
 * @param value - The value to check.
 * @returns True if the value is neither null nor undefined, false otherwise.
 *
 * @example
 * ```ts
 * const array: (string | null | undefined)[] = ['hello', null, 'world', undefined];
 * const nonNullishArray = array.filter(isNonNullish);
 * // nonNullishArray is of type string[] and contains ['hello', 'world']
 * ```
 */
export function isNonNullish<T>(value: T | null | undefined): value is NonNullable<T> {
  return value !== null && value !== undefined
}
